import React from 'react';
import { Swimlane } from '../../../../components/Swimlane/Swimlane';
import { Layout } from '../../../../queries/ats/layout/types';
import { createKey, getPattern } from '../../../../utils/atsLayoutUtils';
import { PatternHandler } from '../../PatternHandler';
import { getSectionLink } from '../../utils';
import styles from '../section-type.module.scss';

function filterOutSeeAll(data: Layout.SectionItem[]) {
  return data.filter((x) => {
    if (x.type !== 'page') {
      return true;
    }

    return x.params?.behavior !== 'see-all';
  });
}

interface SectionSwimlaneProps {
  view: Layout.SectionView;
  data: Layout.SectionItem[];
}

export function SectionSwimlane({ view, data }: SectionSwimlaneProps) {
  const link = getSectionLink(data);

  if (data.length < 10) {
    const items = filterOutSeeAll(data);

    if (items.length === 0) {
      return null;
    }

    return (
      <Swimlane className={styles.container}>
        <Swimlane.Header>
          {view.label.length > 0 && <Swimlane.Title to={link}>{view.label}</Swimlane.Title>}
          <Swimlane.Buttons />
        </Swimlane.Header>
        <Swimlane.Slider>
          {items.map((item, index) => (
            <PatternHandler key={createKey(item)} pattern={getPattern(view.style.pattern, index)} item={item} />
          ))}
        </Swimlane.Slider>
      </Swimlane>
    );
  }

  if (data.length === 0) {
    return null;
  }

  return (
    <Swimlane className={styles.container}>
      <Swimlane.Header>
        {view.label.length > 0 && <Swimlane.Title to={link}>{view.label}</Swimlane.Title>}
        <Swimlane.Buttons />
      </Swimlane.Header>
      <Swimlane.Slider>
        {data.map((item, index) => (
          <PatternHandler key={createKey(item)} pattern={getPattern(view.style.pattern, index)} item={item} />
        ))}
      </Swimlane.Slider>
    </Swimlane>
  );
}

function SectionSwimlaneSkeleton({ view }: Pick<SectionSwimlaneProps, 'view'>) {
  return (
    <Swimlane className={styles.container}>
      <Swimlane.Header>
        {view.label.length > 0 && <Swimlane.Title>{view.label}</Swimlane.Title>}
        <Swimlane.Buttons />
      </Swimlane.Header>
      <Swimlane.Slider>
        {Array.from({ length: 15 }).map((_, index) => (
          <PatternHandler.Skeleton key={index} pattern={getPattern(view.style.pattern, index)} />
        ))}
      </Swimlane.Slider>
    </Swimlane>
  );
}

SectionSwimlane.Skeleton = SectionSwimlaneSkeleton;
